<template>
  <div class="CConfigSetting tc">
    <div class="cont">
      <h2>配置</h2>
      <el-form ref="form" :rules="rules" :model="config" label-width="2rem">
        <template v-if="config.type == '3' && config.unmanShow == '2'">
        <el-form-item label="设备ID：">
          <el-input v-model="config.deviceId" class="input"></el-input>
        </el-form-item>
        </template>
        <template v-else>
        <el-form-item label="设备ID：" prop="deviceId">
          <el-input v-model="config.deviceId" class="input"></el-input>
        </el-form-item>
        </template>
        <el-form-item label="设备类型：" prop="type">
          <div class="typeItem flex" @click="radioType">
            <div class="name" v-if="config.typeName != ''">{{config.typeName}}</div>
            <div class="name col9" v-else>请选择设备类型</div>
            <div class="el-icon-arrow-right"></div>
          </div>
        </el-form-item>
        <template v-if="config.type == '1'">
        <el-form-item label="用途：">
          <el-radio-group v-model="config.unmanShow">
            <el-radio :label="1">借还</el-radio>
            <el-radio :label="2">出入库</el-radio>
          </el-radio-group>
        </el-form-item>
        </template>
        <template v-if="config.type == '3'">
        <el-form-item label="用途：">
          <el-radio-group v-model="config.unmanShow">
            <el-radio :label="1">结算屏</el-radio>
            <el-radio :label="2">大屏展示</el-radio>
          </el-radio-group>
        </el-form-item>
        </template>
        <template v-if="config.type == '3'&&config.unmanShow == '1'">
        <el-form-item label="关联门禁：">
          <el-input v-model="config.accessControl" class="input" placeholder="请输入门禁ID（允许为空）"></el-input>
        </el-form-item>
        </template>
        <template v-if="config.type == '3'&&config.unmanShow == '2'">
        <el-form-item label="关联仓库：">
          <div class="typeItem flex" @click="openWare">
            <div class="name">已关联{{config.wareNum}}个仓库</div>
            <div class="el-icon-arrow-right"></div>
          </div>
        </el-form-item>
        </template>
        <template v-if="config.type != '5'">
        <el-form-item label="通讯地址：">
          <el-input v-model="config.serverPort" class="input"></el-input>
        </el-form-item>
        </template>
        <el-form-item label="业务地址：" prop="address">
          <el-input v-model="config.address" class="input"></el-input>
        </el-form-item>
        <template v-if="config.type == '1' || config.type == '7' || config.type == '4'">
        <el-form-item label="本地地址：">
          <el-input v-model="config.address2" class="input"></el-input>
        </el-form-item>
        </template>
        <el-form-item label="">
          <el-button type="primary" class="confirm" @click="saveForm('form')">确 认</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-button class="backBtn" @click="backIndex" v-if="isBackShow && $store.state.isShowRBot">返回</el-button>

    <el-dialog title="选择设备类型" :visible.sync="typeDio" class="config_typeDio" width="40%">
      <div class="contDio">
        <el-radio-group v-model="configform.type">
          <el-radio :label="item.id" v-for="(item,index) in typeList" :key="index">{{item.name}}</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="typeDio = false">取 消</el-button>
        <el-button type="primary" @click="submitType">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="请关联仓库ID" :visible.sync="wareDio" class="config_typeDio" width="40%">
      <div class="contDio1">
        <div class="item mb20" v-for="(ware,index) in wareData" :key="index">
          <el-input placeholder="仓库ID" v-model="ware.id">
            <el-button slot="append" v-if="index == wareData.length-1" @click="addWare">添加</el-button>
            <el-button slot="append" v-else @click="delWare(index)">删除</el-button>
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wareDio = false">取 消</el-button>
        <el-button type="primary" @click="submitWare">确 定</el-button>
      </span>
    </el-dialog>
    <passWord :isBackShow="isBackShow"></passWord>
  </div>
</template>

<script>
import mqttws from '../assets/mqttws'
import { loginApi } from '../../static/js/api.js'
import { localUserInfo, messageSuccess, messageError, messageClose, showLoading, hideLoading } from '../../static/js/utils/utility.js'
import { storage, clearCountDown } from '../../static/turnoverCabinet/js/utility'
import {checkData} from '../../static/js/utils/util.js'
import * as config from '../../static/js/config.js';
import passWord from '../assets/passWord';
import { officeLockerApi } from '../../static/officeLocker/js/api.js'
export default {
  name: 'CConfigSetting',
  data () {
    return {
      config:{
        deviceId:'',//设备ID
        // addreRadio:'1',
        serverPort:'',//通讯地址
        serverPort2:'',//主题地址
        address:'',//业务地址
        address2:'',//本地业务地址
        type:'',//类型
        typeName:'',//类型名称
        accessControl:'',//门禁ID
        unmanShow:'',//无人仓显示页面类型
        wareNum:0,
        wareList:[{id:''}]
      },
      typeList:[{
        id:'1',
        name:'工具柜'
      },{
        id:'2',
        name:'智能周转柜'
      },{
        id:'3',
        name:'无人仓'
      },{
        id:'4',
        name:'E站'
      },{
        id:'5',
        name:'寄存柜'
      },{
        id:'6',
        name:'物联信报箱'
      },{
        id:'7',
        name:'钥匙柜'
      },{
        id:'8',
        name:'办公寄存柜'
      },
      {
        id:'9',
        name:'会议室预约管理系统'
      },
      {
        id:'10',
        name:'智能售卖柜'
      },
      {
        id:'11',
        name:'生鲜柜'
      },
      ],

      rules:{
        deviceId: [
          { required: true, message: '请输入设备ID', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择设备类型', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入业务地址', trigger: 'blur' },
        ],
        // unmanShow: [
        //   { required: true, message: '请选择用途', trigger: 'blur' },
        // ],
      },

      typeDio:false,
      configform:{
        type:'',
      },

      wareDio:false,
      wareData:[{id:''}],

      isBackShow:false,

      routerList:[{
        type:'1',
        unmanShow:'1',
        path:'/toolCabinet/CLogin'
      },{
        type:'1',
        unmanShow:'2',
        path:'/unmanned/wrcIndex'
      },{
        type:'2',
        path:'/turnoverCabinet'
      },{
        type:'3',
        unmanShow:'1',
        path:'/unmanned/wrcIndex'
      },{
        type:'3',
        unmanShow:'2',
        path:'/unmanned/CExhibition'
      },{
        type:'4',
        path:'/CEsite40s'
        // path:'/eSite'
      },{
        type:'5',
        path:'/locker'
      },{
        type:'6',
        path:'/mailBox'
      },{
        type:'7',
        path:'/keyCabinet'
      },{
        type:'8',
        path:'/officeLocker'
      },{
        type:'9',
        path:'/MRMS'
      },{
        type:'10',
        path:'/Bookcase/Index'
      },{
        type:'11',
        path:'/FreshCabinet'
      },]
    }
  },
  mounted(){    
  },
  components:{
    mqttws,
    passWord
  },
  created() {
    console.log('config', this.config)
    var that = this
    localStorage.setItem('routerList',JSON.stringify(this.routerList));//把配置的跳转路由放到本地存储
    var configStorage = JSON.parse(localStorage.getItem('configStorage'))
    if(configStorage){
      that.config = configStorage
      var project = that.$route.query.project
      if(project){
        that.isBackShow = true;
      }else{
        that.isBackShow = false
        that.backIndex()
      }
    }

  },
  methods:{
    //删除设备ID
    delWare(index){
      this.wareData.splice(index,1)
    },
    //添加设备ID
    addWare(){
      var obj = {
        id:''
      }
      this.wareData.push(obj)
    },
    //打开添加设备弹窗
    openWare(){
      this.wareData = this.config.wareList
      this.wareDio = true
    },
    submitWare(){
      var that = this;
      that.config.wareList = that.wareData
      that.config.wareNum = that.wareData.length
      that.wareDio = false;
    },
    submitType(){
      var that = this;
      that.config.type = that.configform.type
      for(var i in that.typeList){
        if(that.configform.type==that.typeList[i].id){
          that.config.typeName=that.typeList[i].name
        }
      }
      // that.config.typeName = that.typeList.find(item => item.id == that.configform.type)["name"];
      that.config.accessControl = ''
      that.config.unmanShow = ''
      that.typeDio = false;
      that.configform.type = ''
    },
    //打开类型选择弹窗
    radioType(){
      this.configform.type = this.config.type
      this.typeDio = true;
    },
    saveForm(formName){
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          localStorage.setItem('configStorage', JSON.stringify(that.config))
          that.backIndex();
          
          // setTimeout(function(){
          //   that.$router.go(0);//解决static的config文件无法动态写入问题
          // },1000)
        } else {
          return false;
        }
      });
      
    },
    //跳转到项目页
    backIndex(){
      var that = this
      var routerList = JSON.parse(localStorage.getItem('routerList'))
      for(var i in routerList){
        if(that.config.type == routerList[i].type){
          if(that.config.type == 2||that.config.type==5||that.config.type==6||that.config.type==8){
            storage.localSetItem('device_no_id', that.config.deviceId)
          }
          if(that.config.type == 4 || that.config.type == 11){
            //暂时为E站存放以下三个参数
            var configStorage = storage.localGetItem('configStorage')
            if(configStorage){
              configStorage.company_name = 'abcd'
              configStorage.phone_no = '13417795010'
              configStorage.password = 'Geekuiot2017'
            }
            storage.localSetItem('configStorage',configStorage)
          }
          if(routerList[i].unmanShow){
            if(that.config.unmanShow == routerList[i].unmanShow){
              that.$router.push({
                path: routerList[i].path
              })
            }
          }else{
            that.$router.push({
              path: routerList[i].path
            })
          }
        }
      }
      // switch(that.config.type)
      // {
      // case '1':
      //   // that.$router.push({
      //   //   path:'/toolCabinet/CLogin',
      //   // })
      //   if(that.config.unmanShow == '1'){
      //     that.$router.push({
      //       path:'/toolCabinet/CLogin',
      //     })
      //   }else{
      //     that.$router.push({
      //       path:'/unmanned/wrcIndex',
      //     })
      //   }
      //   break;
      // case '2':
      //   storage.localSetItem('device_no_id', that.config.deviceId)
      //   that.$router.push({
      //     path:'/turnoverCabinet',
      //   })
      //   break;
      // case '3':
      //   if(that.config.unmanShow == '1'){
      //     that.$router.push({
      //       path:'/unmanned/wrcIndex',
      //     })
      //   }else{
      //     that.$router.push({
      //       path:'/unmanned/CExhibition',
      //     })
      //   }
      //   break;
      // case '4':
      //   storage.localSetItem('device_no_id', that.config.deviceId)
      //   that.$router.push({
      //     path:'/eSite',
      //   })
      //   break;
      // case '5':
      //   storage.localSetItem('device_no_id', that.config.deviceId)
      //   that.$router.push({
      //     path:'/locker',
      //   })
      //   break;
      // case '6':
      //   storage.localSetItem('device_no_id', that.config.deviceId)
      //   // console.log('device_no_id:', storage.localGetItem('device_no_id'))
      //   that.$router.push({
      //     path:'/mailBox',
      //   })
      //   break;
      // case '7':
      //   that.$router.push({
      //     path:'/keyCabinet',
      //   })
      //   break;
      // case '8':
      //   storage.localSetItem('device_no_id', that.config.deviceId)
      //   // that.getDeviceInfo()
      //     that.$router.push({
      //       path:'/officeLocker',
      //     })
      //   break;
      // case '9':
      //     that.$router.push({
      //       path:'/MRMS',
      //     })
      //   break;
      // default:
      //   break;
      // }
    },

    // 办公寄存柜获取设备信息
    async getDeviceInfo(){
      let that = this
      showLoading('正在配置')
      let res = await officeLockerApi.getDeviceInfo()
      hideLoading()
      if (res.meta.code == 200) {
        that.$store.state.officeLocker_deviceInfo.scene = res.data.scene
        messageSuccess('配置成功')
        setTimeout(function () {
          messageClose()
          that.$router.push({
            path:'/officeLocker',
          })
        }, 1000)
      } else {
        messageError(res.meta.message)
      }
    },
    
  },
  watch :{
    
  },
}
</script>

<style lang="less">
.el-select-dropdown__item{
  font-size: 0.14rem;
  padding: 0 0.2rem;
  height: 0.34rem;
  line-height: 0.34rem;
}
.el-input__icon{ line-height: 0.4rem; margin-right: 0.1rem;}
.el-select .el-input .el-select__caret{ font-size: 0.12rem;}
.CConfigSetting{
  // height: 100vh;
  // background: url('../../static/images/bg.jpg') center no-repeat;
  // background-size: cover;
  .backBtn{
    position: absolute;
    right: 0.94rem;
    bottom: 0.47rem;
    height: 0.94rem;
    width: 2.54rem;
    padding: 0 !important;
    font-size: 0.4rem !important;
    color: #fff;
    font-weight: bold;
    border: none;
    border-radius: 0.12rem;
    line-height:0.94rem;
    background: linear-gradient(#4aaafe, #0769be);
    z-index: 2;
  }
  .cont{
    width: 60%;
    padding-top: 3%;
    margin: 0 auto;
    font-size: 0.5rem;
    color: #fff;
    h2{margin-bottom: 0.4rem;}
    .el-form-item{ margin-bottom: 0.4rem;}
    .el-form-item__label{
      font-size: 0.3rem;
      color: #fff;
      line-height: 0.8rem;
      padding: 0 0.12rem 0 0;
    }
    .el-form-item__content {
      line-height: 0.8rem;
      font-size: 0.3rem;
      .el-form-item__error{
        font-size: 0.3rem;
      }
      .el-radio-group{
        display: flex;
        align-items: center;
        height: 0.8rem;
      }
      .el-radio{
        display: inline-flex;
        align-items: center;
        margin:0 0.2rem;
        .el-radio__inner{
          width: 0.4rem;
          height: 0.4rem;
          border:0.02rem solid #DCDFE6;
          &::after{
            width: 0.16rem;
            height: 0.16rem;
          }
        }
        .el-radio__label{
          color: #fff;
          font-size: 0.3rem;
        }
      }
      .confirm{
        height: 0.94rem;
        padding: 0 !important;
        font-size: 0.4rem !important;
        color: #fff;
        font-weight: bold;
        border: none;
        border-radius: 0.12rem;
        line-height:0.94rem;
        background: linear-gradient(#4aaafe, #0769be);
        width: 100%;
      }
      .flex{
        align-items: center;
        .item2{
          flex-grow: 1;
        }
      }
      .typeItem{
        justify-content: space-between;
        align-items: center;
        height: 0.8rem;
        border:0.02rem solid #fff;
        padding: 0 0.1rem;
        border-radius: 0.1rem;
        .col9{ color:#999; }
      }
      .el-radio-button__inner{
        font-size: 0.3rem;
        padding: 0.12rem 0.2rem;
      }
      .input .el-input__inner{
        height: 0.8rem;
        line-height: 0.8rem;
        padding: 0 0.15rem;
        color: #fff;
        font-size: 0.3rem;
        background: none;
        border: none;
        border-bottom: 0.02rem solid #fff;
      }
      .select{
        display: block;
        .el-input__inner{
          height: 0.8rem;
          line-height: 0.8rem;
          padding: 0 0.15rem;
          color: #fff;
          font-size: 0.3rem;
          background: none;
        }
      }
    }
  }
}
.config_typeDio{
  .contDio{
    max-height: 4rem;
    overflow: auto;
  }
  .el-radio-group{
    display: block;
  }
  .mb20{ margin-bottom: 0.2rem;}
  .el-radio{
    display: flex;
    justify-content: space-between;
    flex-direction:row-reverse;
    align-items: center;
    margin:0 0 0.4rem;
    .el-radio__inner{
      width: 0.4rem;
      height: 0.4rem;
      border:0.02rem solid #DCDFE6;
      &::after{
        width: 0.16rem;
        height: 0.16rem;
      }
    }
    .el-radio__label{
      font-size: 0.3rem;
    }
  }
  .el-input__inner{
    height: 0.8rem;
    line-height: 0.8rem;
    font-size: 0.3rem;
  }
  .el-input-group__append .el-button{
    font-size: 0.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CConfigSetting.vue